// /setup?modal=add-category (finance-real round 3, DD-051, DD-056): a category named on its own, from Setup's Expense
// categories panel, before any expense uses it. Names stay unique per agency in any case, and the server says so on a clash.
// finance-real round 8: it can be made a pot here (slice 9, J41).
import { useState } from "react";
import { Button } from "@/components/ui/Button";
import { FormField, inputClassName } from "@/components/ui/FormField";
import { ENTITY_CONFIG } from "@/core/entityConfig";
import { FinanceDrawer } from "../components/FinanceDrawer";
import { MissingLine, Required } from "../components/Required";
import { useCreateCategory } from "../hooks/useExpenses";
import { useSubmitOnce } from "../hooks/useSubmitOnce";
import { closeUnlessPending } from "../utils/mutations";
import { PotCheckbox } from "./PotCheckbox";

const CATEGORY = ENTITY_CONFIG.expenseCategory;

export function AddCategoryDrawer({ onClose }: { onClose: () => void }) {
  const [label, setLabel] = useState("");
  const [pot, setPot] = useState(false);
  const create = useCreateCategory();
  const send = useSubmitOnce();
  const ready = label.trim() !== "";
  const add = () => send(() => create.mutateAsync({ label: label.trim(), pot }), () => onClose());
  return (
    <FinanceDrawer
      onClose={closeUnlessPending(create.isPending, onClose)}
      title={CATEGORY.createLabel}
      footer={
        <Button onClick={add} disabled={!ready || create.isPending} isLoading={create.isPending}>
          {CATEGORY.createLabel}
        </Button>
      }
    >
      <div className="space-y-3">
        <FormField label={<Required>Name</Required>} hint={`Pick it when you add an ${ENTITY_CONFIG.expense.label.toLowerCase()}.`}>
          <input className={inputClassName} aria-label="Name" aria-required="true" value={label} placeholder="e.g. Software" onChange={(e) => setLabel(e.target.value)} autoFocus />
        </FormField>
        <PotCheckbox checked={pot} onChange={setPot} disabled={create.isPending} />
        <MissingLine button={CATEGORY.createLabel} missing={ready ? [] : ["the name"]} />
      </div>
    </FinanceDrawer>
  );
}
